import { Controller, useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import { tw } from "@careinfo/tailwind";
import { useEffect } from "react";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import NumberField from "../Reusable/NumField";

interface OtherChargesProps {
  setIsOpen: (open: boolean) => void;
  existingCharges?: Record<string, number>;
  isOpen?: any;
  selectedId?: any;
  updateCharges: (data: Record<string, number>) => void;
}

const OtherCharges = (props: OtherChargesProps) => {
  const { existingCharges, updateCharges, setIsOpen, selectedId } = props;
  const {
    data: templateData,
    refetch,
    isLoading,
  } = useGetHook({
    queryKey: [`delivery-charge-template-${selectedId}`],
    url: `${APIS.DELIVERY_CHARGE_TEMPLATE}${selectedId}/`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    reset,
    control,
  } = useForm<any>({
    defaultValues: {
      insurance_charge: null,
      odd_size_charge: null,
      packaging_charge: null,
      nepal_custom_clearance: null,
      tia_charge: null,
      fsc_charge: null,
      bad_address_charge: null,
      remote_charge: null,
      re_forwarding: null,
      documentation_charge: null,
      pickdrop_charge: null,
      archaeology: null,
      extra_packaging_charge: null,
      extra_charge: null,
    },
  });

  useEffect(() => {
    if (templateData?.other_charges) {
      const charges = templateData.other_charges;
      reset({
        insurance_charge: charges.insurance_charge || null,
        odd_size_charge: charges.odd_size_charge || null,
        packaging_charge: charges.packaging_charge || null,
        nepal_custom_clearance: charges.nepal_custom_clearance || null,
        tia_charge: charges.tia_charge || null,
        fsc_charge: charges.fsc_charge || null,
        bad_address_charge: charges.bad_address_charge || null,
        remote_charge: charges.remote_charge || null,
        re_forwarding: charges.re_forwarding || null,
        documentation_charge: charges.documentation_charge || null,
        pickdrop_charge: charges.pickdrop_charge || null,
        archaeology: charges.archaeology || null,
        extra_packaging_charge: charges.extra_packaging_charge || null,
        extra_charge: charges.extra_charge || null,
      });
    } else {
    }
  }, [templateData, reset]);

  const onSubmit = (data: any) => {
    const numericData: Record<string, number> = {};
    Object.keys(data).forEach((key) => {
      numericData[key] = Number(data[key] || 0);
    });
    updateCharges(numericData);
    setIsOpen(false);
  };
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <section className={tw`bg-white rounded-lg w-full mx-auto p-4`}>
      <form onSubmit={handleSubmit(onSubmit)} className={tw``}>
        <div className={tw`flex gap-x-4`}>
          <Controller
            name="insurance_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Insurance Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.insurance_charge}
              />
            )}
          />

          <Controller
            name="odd_size_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Odd Size Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.odd_size_charge}
              />
            )}
          />
        </div>

        <div className={tw`flex gap-x-4`}>
          <Controller
            name="packaging_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Packaging Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.packaging_charge}
              />
            )}
          />

          <Controller
            name="nepal_custom_clearance"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Nepal Custom Clearance"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.nepal_custom_clearance}
              />
            )}
          />
        </div>

        <div className={tw`flex gap-4`}>
          <Controller
            name="tia_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="TIA Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.tia_charge}
              />
            )}
          />

          <Controller
            name="fsc_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="FSC Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.fsc_charge}
              />
            )}
          />
        </div>

        <div className={tw`flex gap-4`}>
          <Controller
            name="bad_address_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Bad Address Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.bad_address_charge}
              />
            )}
          />
          <Controller
            name="remote_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Remote Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.remote_charge}
              />
            )}
          />
        </div>
        <div className={tw`flex gap-4`}>
          <Controller
            name="re_forwarding"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Re Forwarding Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.re_forwarding}
              />
            )}
          />
          <Controller
            name="documentation_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Documentation Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.documentation_charge}
              />
            )}
          />
        </div>
        <div className={tw`flex gap-4`}>
          <Controller
            name="pickdrop_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Pickup & Drop Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.pickdrop_charge}
              />
            )}
          />
          <Controller
            name="archaeology"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Archaeology Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.archaeology_charge}
              />
            )}
          />
        </div>
        <div className={tw`flex gap-4`}>
          <Controller
            name="extra_packaging_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Extra Packaging Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.extra_packaging_charge}
              />
            )}
          />
          <Controller
            name="extra_charge"
            control={control}
            rules={{
              min: { value: 1, message: "Amount must be greater than 0" },
            }}
            render={({ field }) => (
              <NumberField
                label="Extra Charge"
                placeholder="0"
                value={field.value}
                onChange={field.onChange}
                errors={errors?.extra_charge}
              />
            )}
          />
        </div>

        <div className={tw`flex justify-end gap-4 mt-6`}>
          <Button
            type="button"
            label="Cancel"
            color="bg-gray-500 hover:bg-gray-600"
            onClick={() => setIsOpen(false)}
            className={tw`w-32`}
          />
          <Button
            type="submit"
            label="Submit"
            color="bg-blue-500 hover:bg-blue-600"
            className={tw`w-32`}
          />
        </div>
      </form>
    </section>
  );
};

export default OtherCharges;
